/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RttrClaimSocialLikeResponse
 */
export interface RttrClaimSocialLikeResponse {
    /**
     * 
     * @type {number}
     * @memberof RttrClaimSocialLikeResponse
     */
    pointsAwarded: number;
    /**
     * 
     * @type {string}
     * @memberof RttrClaimSocialLikeResponse
     */
    platform: string;
    /**
     * 
     * @type {number}
     * @memberof RttrClaimSocialLikeResponse
     */
    segmentIndex: number;
    /**
     * 
     * @type {string}
     * @memberof RttrClaimSocialLikeResponse
     */
    postIdentifier: string;
}

/**
 * Check if a given object implements the RttrClaimSocialLikeResponse interface.
 */
export function instanceOfRttrClaimSocialLikeResponse(value: object): value is RttrClaimSocialLikeResponse {
    if (!('pointsAwarded' in value) || value['pointsAwarded'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    if (!('segmentIndex' in value) || value['segmentIndex'] === undefined) return false;
    if (!('postIdentifier' in value) || value['postIdentifier'] === undefined) return false;
    return true;
}

export function RttrClaimSocialLikeResponseFromJSON(json: any): RttrClaimSocialLikeResponse {
    return RttrClaimSocialLikeResponseFromJSONTyped(json, false);
}

export function RttrClaimSocialLikeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrClaimSocialLikeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'pointsAwarded': json['pointsAwarded'],
        'platform': json['platform'],
        'segmentIndex': json['segmentIndex'],
        'postIdentifier': json['postIdentifier'],
    };
}

export function RttrClaimSocialLikeResponseToJSON(json: any): RttrClaimSocialLikeResponse {
    return RttrClaimSocialLikeResponseToJSONTyped(json, false);
}

export function RttrClaimSocialLikeResponseToJSONTyped(value?: RttrClaimSocialLikeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pointsAwarded': value['pointsAwarded'],
        'platform': value['platform'],
        'segmentIndex': value['segmentIndex'],
        'postIdentifier': value['postIdentifier'],
    };
}

